import { findHallOrUserByIdentifier } from '$logic/hall'
import { openUserProfile } from '$logic/router'
import { openRoom } from '$logic/opened-room'
import { showIdentifierDoesNotExistSnackbar } from '$comp/snackbars'

export async function onIdentifierClick(identifier: string) {
  const res = await findHallOrUserByIdentifier(identifier)
  if (!res) {
    showIdentifierDoesNotExistSnackbar()
    return
  }
  const [type, data] = res
  if (type === 'user') openUserProfile(data.id)
  else openRoom(data.roomId)
}
